import z from 'zod'

export const BaseEntitySchema = z.object({
  createdAt: z.string().nullish(),
  updatedAt: z.string().nullish(),
  deletedAt: z.string().nullish()
}).strict()

enum AssetType {
  COVER = 'COVER',
  PROFILE_PICTURE = 'PROFILE_PICTURE'
}

export const SocialChannelPlatforms = [
  'instagram',
  'tiktok',
  'X',
  'facebook',
  'linkedIn',
  'snapchat',
  'youtube',
  'reddit',
  'website',
  'other'
] as const

export type SocialChannelPlatform = (typeof SocialChannelPlatforms)[number]

export const AssetsResponseSchema = z.object({
  [AssetType.COVER]: z.string().nullish(),
  [AssetType.PROFILE_PICTURE]: z.string().nullish()
}).strict()

export const UserDetailsSchema = BaseEntitySchema.extend({
  firstName: z.string(),
  fullName: z.string(),
  id: z.uuid(),
  lastName: z.string(),
  city: z.string(),
  state: z.string(),
  country: BaseEntitySchema.extend({
    id: z.number().int(),
    name: z.string().nullish(),
    isoCode: z.string().nullish(),
  }).strict(),
}).strict()

export type UserDetails = z.infer<typeof UserDetailsSchema>
